// eslint-disable-next-line @typescript-eslint/naming-convention
export enum Borrower1099_CategoryEnum {
  BorrowerIncome = 'Borrower Income',
  CoborrowerIncome = 'Coborrower Income',
}

export enum BorrowerBranchOfService {
  Airforce = 'Airforce',
  Army = 'Army',
  CoastGuard = 'Coast Guard',
  Marine = 'Marine',
  Navy = 'Navy',
}

export enum BorrowerClosingDisclosureCategoryEnum {
  HomeVerification = 'Home Verification',
}

export enum BorrowerDirectDepositAuthorizationFormCategoryEnum {
  Funding = 'Funding',
}

export enum BorrowerDriversLicenseBackMustBeInColorCategoryEnum {
  BorrowerID = 'Borrower ID',
  CoborrowerID = 'Coborrower ID',
}

export enum BorrowerEmployerState {
  Ak = 'AK',
  Al = 'AL',
  Ar = 'AR',
  Az = 'AZ',
  CA = 'CA',
  CT = 'CT',
  Co = 'CO',
  Dc = 'DC',
  De = 'DE',
  FL = 'FL',
  Ga = 'GA',
  Hi = 'HI',
  ID = 'ID',
  IL = 'IL',
  Ia = 'IA',
  In = 'IN',
  Ks = 'KS',
  Ky = 'KY',
  La = 'LA',
  MS = 'MS',
  MT = 'MT',
  Ma = 'MA',
  Md = 'MD',
  Me = 'ME',
  Mi = 'MI',
  Mn = 'MN',
  Mo = 'MO',
  Nc = 'NC',
  Nd = 'ND',
  Ne = 'NE',
  Nh = 'NH',
  Nj = 'NJ',
  Nm = 'NM',
  Nv = 'NV',
  Ny = 'NY',
  Oh = 'OH',
  Ok = 'OK',
  Or = 'OR',
  Pa = 'PA',
  Ri = 'RI',
  SD = 'SD',
  Sc = 'SC',
  Tn = 'TN',
  Tx = 'TX',
  Ut = 'UT',
  VT = 'VT',
  Va = 'VA',
  Wa = 'WA',
  Wi = 'WI',
  Wv = 'WV',
  Wy = 'WY',
}

export enum BorrowerEmploymentStatus {
  ActiveMilitaryW2 = 'Active Military (W2)',
  EmployedW2 = 'Employed (W2)',
  GovernmentW2 = 'Government (W2)',
  Homemaker = 'Homemaker',
  RetiredMilitary = 'Retired Military',
  RetiredNonMilitary = 'Retired (non-military)',
  SelfEmployed1099 = 'Self-Employed/1099',
}

export enum BorrowerGovernmentPaygrade {
  Gs1 = 'GS1',
  Gs10 = 'GS10',
  Gs11 = 'GS11',
  Gs12 = 'GS12',
  Gs13 = 'GS13',
  Gs14 = 'GS14',
  Gs15 = 'GS15',
  Gs2 = 'GS2',
  Gs3 = 'GS3',
  Gs4 = 'GS4',
  Gs5 = 'GS5',
  Gs6 = 'GS6',
  Gs7 = 'GS7',
  Gs8 = 'GS8',
  Gs9 = 'GS9',
}
export enum BorrowerHomeImprovementEstimatesOrContractsCategoryEnum {
  ContractorWorkOrderS = 'Contractor Work Order(s)',
}

export enum BorrowerMilitaryPaygrade {
  E1 = 'E1',
  E2 = 'E2',
  E3 = 'E3',
  E4 = 'E4',
  E5 = 'E5',
  E6 = 'E6',
  E7 = 'E7',
  E8 = 'E8',
  E9 = 'E9',
  O1 = 'O1',
  O10 = 'O10',
  O1E = 'O1E',
  O2 = 'O2',
  O2E = 'O2E',
  O3 = 'O3',
  O3E = 'O3E',
  O4 = 'O4',
  O5 = 'O5',
  O6 = 'O6',
  O7 = 'O7',
  O8 = 'O8',
  O9 = 'O9',
  W1 = 'W1',
  W2 = 'W2',
  W3 = 'W3',
  W4 = 'W4',
  W5 = 'W5',
}

export enum LoanTerm {
  TwoYears = '2',
  ThreeYears = '3',
  FourYears = '4',
  FiveYears = '5',
  SixYears = '6',
  SevenYears = '7',
  SevenPointFiveYears = '7.5',
  EightYears = '8',
  NineYears = '9',
  TenYears = '10',
  ElevenYears = '11',
  TwelveYears = '12',
  ThirteenYears = '13',
  FourteenYears = '14',
  FifteenYears = '15',
  SixteenYears = '16',
  SeventeenYears = '17',
  EighteenYears = '18',
  NineteenYears = '19',
  TwentyYears = '20',
  ThirtyYears = '30',
}

export enum OtherDocumentCategory {
  BorrowerID = 'Borrower ID',
  BorrowerIncome = 'Borrower Income',
  BorrowerOther = 'Borrower Other',
  CoborrowerID = 'Coborrower ID',
  CoborrowerIncome = 'Coborrower Income',
  CoborrowerOther = 'Coborrower Other',
  ContractorWorkOrderS = 'Contractor Work Order(s)',
  Funding = 'Funding',
  HomeVerification = 'Home Verification',
}

export enum Status {
  Upload = 'Upload',
  Pending = 'Pending',
  Confirmed = 'Confirmed',
}

export enum BorrowerLetterOfExplanationCategoryEnum {
  BorrowerOther = 'Borrower Other',
  CoborrowerOther = 'Coborrower Other',
}

export enum Lender {
  Lfcu = 'LFCU',
  SeattleBank = 'Seattle Bank',
  USAlliance = 'US Alliance',
  RizeCU = 'Rize CU',
  Quilo = 'Quilo',
  Prosper = 'Prosper',
  Mit = 'MIT',
  Bhg = 'BHG',
  Tic = 'TIC',
  Chartway = 'Chartway',
  InFirstFcu = 'InFirst FCU',
  MsdFcu = 'MSD FCU',
  CopperStateCu = 'Copper State CU',
}

export enum ContractorNameSource {
  Autofill = 'Autofill',
  Manual = 'Manual',
  PromoLink = 'Promo Link',
  Empty = 'Empty',
}

export enum CurrentOwnershipStatus {
  OwnWithMortgage = 'Own with Mortgage',
  OwnFreeClear = 'Own Free & Clear',
  Rent = 'Rent',
  LiveWithParents = 'Live With Parents',
}

export enum PrequalificationVersion {
  First = '1',
  Second = '2',
}

export enum KbaStatus {
  Expired = 'Expired',
  Failed = 'Failed',
  Passed = 'Passed',
  Unavailable = 'Unavailable',
}

export enum AutomatedOfferResult {
  Accepted = 'Accepted',
  Rejected = 'Rejected',
  Expired = 'Expired',
  FailedConditions = 'Failed Conditions',
}
